module.exports = __webpack_public_path__ + "img/curriculum-vitae.f16d63b4.svg";